import { render, staticRenderFns } from "./DashIntakeReferrals.vue?vue&type=template&id=df198122&scoped=true&"
import script from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"
export * from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df198122",
  null
  
)

export default component.exports